<div class="pageContent">
    <div class="pageTitle">
      <h2>Permisos Menú</h2>
    </div>
    <app-data-table tableId="datatableGrupos" [serverSide]="true" [serverData]="getDataTableMenu" [columns]="columnas" [customColumns]="columnasPersonalizadas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
</div>



